import SuppliersFilters from './FiltersPage';

export default SuppliersFilters;
